import React, { useEffect, useRef, useState } from 'react'
import "./showproducts.css"
import ProductSang from '../../Products/ProductSang'
import CategoryProductSang from '../../Products/CategoryProductSang'
import { useMediaQuery } from 'react-responsive';
import { XCircleIcon } from '@heroicons/react/16/solid'
import ProductAhan from '../../Products/ProductAhan';
import CategoryProductAhan from '../../Products/CategoryProductAhan';
import CompanysSang from '../../Products/CompanysSang';
import CompanyProductSang from '../../Products/CompanyProductSang';
import CompanysAhan from '../../Products/CompanysAhan';
import CompanyProductAhan from '../../Products/CompanyProductAhan';
import { useLocation, useParams } from 'react-router-dom';
import Loader from '../../../Loader/Loader';



function ShowAllProducts() {
    const isMobile = useMediaQuery({ query: '(max-width: 1000px)' });
    const [isHamberGer , setIsHamberGer] = useState(false)
    // const [isLoader , setIsLoader] = useState(true)
    const filterRef = useRef(null);
    const [scrollAmount, setScrollAmount] = useState(150);
    const [activeBtn , setActiveBtn] = useState('')
    const [idCategory , setIdCategory] = useState(-1)
    const [idCompany , setIdCompany] = useState(-1)
    const [allCompany , setAllCompany] = useState([])
    const [filterProduct , setFilterProduct] = useState(null)
    const [nameCompany , setNameCompany] = useState("")

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const NameProductParam = queryParams.get('name');
    const IDCategoryParam = queryParams.get('id');
    useEffect(() => {
        setActiveBtn(NameProductParam)
        if (IDCategoryParam) {
            setIdCategory(+IDCategoryParam)
        }
        
    },[NameProductParam])

    const [isFixed, setIsFixed] = useState(false);
    const companyRef = useRef(null);
    const menuRef = useRef(null);
    useEffect(() => {
        const handleScroll = () => {
            if (isMobile){
                return setIsFixed(false)
            }
        if (menuRef.current && companyRef.current) {
            const menuBottom = menuRef.current.getBoundingClientRect().bottom;
            if (activeBtn) {
            if (activeBtn === "stone") {
                menuBottom < 400 ? setIsFixed(true) : setIsFixed(false);
            } else {
                menuBottom < 660 ? setIsFixed(true) : setIsFixed(false);
            }
            }
        }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [activeBtn]);

    useEffect(() => {

        if (idCategory != -1) {
            let FilterCompany ;
            if (activeBtn === "stone") {
                FilterCompany = CompanysSang.filter((item) => {
                    return item.CompanyCategoryId?.some((id) => id === idCategory);
                });
                if(FilterCompany.length <= 0){
                    FilterCompany = CompanysSang.filter((id) => id.ID === -1)
                }
                setAllCompany(FilterCompany)
            }
            else{
                FilterCompany = CompanysAhan.filter((item) => {
                    return item.CompanyCategoryId?.some((id) => id === idCategory);
                });
                if(FilterCompany.length <= 0){
                    FilterCompany = CompanysAhan.filter((id) => id.ID === -1)
                }
                setAllCompany(FilterCompany)
            }
        }

        if(idCategory === -1 && idCompany === -1) {
            if(activeBtn === "stone"){
                setAllCompany(CompanysSang)
                return setFilterProduct(ProductSang)
            }
            setAllCompany(CompanysAhan)
            return setFilterProduct(ProductAhan)
        }
        if (idCompany === -1) {
            if(activeBtn === "stone"){
                const FilterStone = ProductSang.filter((p) => p.CategoryID === idCategory)
                if(FilterStone.length <= 0 ){
                    return setIdCategory(-1)
                }
                
            return setFilterProduct(ProductSang.filter((p) => p.CategoryID === idCategory))
            }
            else {
                const FilterIron = ProductAhan.filter((p) => p.CategoryID === idCategory)
                if(FilterIron.length <= 0 ){
                    return setIdCategory(-1)
                }
                return setFilterProduct(ProductAhan.filter((p) => p.CategoryID === idCategory))
            }
        }
        if (idCategory === -1) {
            if(activeBtn === "stone"){
                const FilterStone = CompanyProductSang.filter((p) => p.CID === idCompany)
                const ProdcuctComapnyS = []
                FilterStone.forEach((item) => {
                    const foundProduct = ProductSang.find((p) => p.ID === item.PID)
                    if (foundProduct) {
                        ProdcuctComapnyS.push(foundProduct)
                    }
                })
                return setFilterProduct(ProdcuctComapnyS)
            }
            else {
                const FilterStone = CompanyProductAhan.filter((p) => p.CID === idCompany)
                const ProdcuctComapnyA = []
                FilterStone.forEach((item) => {
                    const foundProduct = ProductAhan.find((p) => p.ID === item.PID)
                    if (foundProduct) {
                        ProdcuctComapnyA.push(foundProduct)
                    }
                })
                return setFilterProduct(ProdcuctComapnyA)
            }
        }

        if (activeBtn === "stone") {
            const FilterStone = CompanyProductSang.filter((p) => p.CID === idCompany)
            const ProdcuctComapnyS = []
            FilterStone.forEach((item) => {
                const foundProduct = ProductSang.find((p) => p.ID === item.PID)
                if (foundProduct) {
                    ProdcuctComapnyS.push(foundProduct)
                }
            })
            const filtercompanandcategory = ProdcuctComapnyS.filter((product) => product.CategoryID === idCategory)
            return setFilterProduct(filtercompanandcategory)
        }
        else
        {
            const NameCompany = CompanysAhan.find((id) => id.ID === idCompany)
            setNameCompany(NameCompany.Name)
            
            const FilterStone = CompanyProductAhan.filter((p) => p.CID === idCompany)
            const ProdcuctComapnyS = []
            FilterStone.forEach((item) => {
                const foundProduct = ProductAhan.find((p) => p.ID === item.PID)
                if (foundProduct) {
                    ProdcuctComapnyS.push(foundProduct)
                }
            })
            const filtercompanandcategory = ProdcuctComapnyS.filter((product) => product.CategoryID === idCategory)
            return setFilterProduct(filtercompanandcategory)
        }

    },[idCategory , activeBtn , idCompany])

    useEffect(() => {
        setIdCompany(-1)
    },[idCategory])

    useEffect(() =>{
        window.scrollTo(0, 0)
    },[idCategory , idCompany , activeBtn])

  const scrollLeft = () => {    
    filterRef.current.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  };

  const scrollRight = () => {
    filterRef.current.scrollBy({        
      left: -scrollAmount,
      behavior: 'smooth'
    });
  };

    return (

    <div className='container-products'>
        <div className='products-filter'>
                <div className='Allproduct'>
                    <div className='c-filterCompany' style={{position: isFixed ? 'relative' : 'sticky', top: isFixed ? '0' : '0'}}  ref={companyRef} >  
                        {
                            isMobile ?
                            <>
                                <div className='c-icon-hamberger' onClick={() => setIsHamberGer(!isHamberGer)}>
                                    {/* <svg className='icon-hamberger-menue' fill="black" height="512" viewBox="0 0 24 24" ><path d="m2.25 5c0-.414.336-.75.75-.75h13c.414 0 .75.336.75.75s-.336.75-.75.75h-13c-.414 0-.75-.336-.75-.75zm18.75 6.25h-18c-.414 0-.75.336-.75.75s.336.75.75.75h18c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm-9 7h-9c-.414 0-.75.336-.75.75s.336.75.75.75h9c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z" fill="black"/></svg> */}
                                    <svg className='icon-hamberger-menue' id="Layer_1" nable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><path d="m229.297 238.933h265.636c9.426 0 17.067 7.641 17.067 17.067s-7.641 17.067-17.067 17.067h-265.637c-7.54 28.549-33.539 49.599-64.458 49.599-30.943 0-56.96-21.083-64.476-49.666l-83.295.001c-9.389 0-17-7.612-17-17 0-9.389 7.611-17 17-17l83.295-.001c7.516-28.584 33.533-49.667 64.476-49.667 30.92 0 56.919 21.05 64.459 49.6zm189.856-189.333h75.78c9.426 0 17.067 7.641 17.067 17.067s-7.641 17.067-17.067 17.067h-75.78c-7.539 28.55-33.539 49.6-64.458 49.6s-56.919-21.05-64.458-49.6h-273.17c-9.426 0-17.067-7.642-17.067-17.067 0-9.426 7.641-17.067 17.067-17.067h273.17c7.539-28.55 33.539-49.6 64.458-49.6s56.919 21.05 64.458 49.6zm-142.538 462.4c-30.92 0-56.919-21.05-64.459-49.6h-195.089c-9.426 0-17.067-7.641-17.067-17.067s7.641-17.067 17.067-17.067h195.09c7.54-28.55 33.539-49.6 64.459-49.6 30.919 0 56.919 21.05 64.458 49.6h153.86c9.426 0 17.067 7.641 17.067 17.067s-7.641 17.067-17.067 17.067h-153.86c-7.54 28.55-33.54 49.6-64.459 49.6z"/></svg>
                                </div>
                                <div className='line'></div>
                            </>
                            :
                            ""
                        }

                        {/* <button className="scroll-btn" onClick={scrollLeft}>◄</button> */}
                        <div className='c-scrollbtn responsiveClass'  onClick={scrollLeft}>
                            <svg className='scroll-btn' viewBox="0 0 12.296 6.624"><defs></defs><g transform="translate(0 6.624) rotate(-90)"><path d="M1.142,6.151,6.486.808A.473.473,0,0,0,5.817.139L.139,5.817a.473.473,0,0,0,0,.669l5.678,5.678a.473.473,0,0,0,.669-.669Z"/></g></svg>
                        </div>
                            <div className='filterCompany' ref={filterRef}>
                                {
                                    allCompany.map((item) => {
                                        return(
                                            <p key={item.ID} className={` ${idCompany === item.ID ? "active" : ""}`} onClick={() => setIdCompany(item.ID)} >{item.Name}</p>
                                        )
                                    })
                                }
                            </div>
                        <div className='c-scrollbtn btn-left'  onClick={scrollRight}>
                            <svg className='scroll-btn' viewBox="0 0 12.296 6.624"><defs></defs><g transform="translate(0 6.624) rotate(-90)"><path d="M1.142,6.151,6.486.808A.473.473,0,0,0,5.817.139L.139,5.817a.473.473,0,0,0,0,.669l5.678,5.678a.473.473,0,0,0,.669-.669Z"/></g></svg>
                        </div>
                        {/* <button className="scroll-btn" onClick={scrollRight}>►</button> */}
                    </div>  
                    <div className='c-AllProduct'>
                        <div className='c-p-products'>
                            { activeBtn === "stone" ?  
                                filterProduct?.length > 0 ? 

                                    filterProduct?.map((item) => {
                                        return (
                                            <div className="p-Product" key={item.ID}>
                                                <div className='c-img'> <img  src={item.ImageURL} alt="محصول 1" /> </div>
                                                <div className='name-product'>
                                                    <div className='handleText'> <span>{item.Name}</span> <span> {item.Details} </span> </div>
                                                    <div className='showName-Details'> <div> <span>{item.Name}</span> <span> {item.Details} </span>  </div> </div>
                                                    <div>{item.CompanyName}</div>
                                                    {/* <p> 330،000 تومان </p> */}
                                                </div>
                                            </div>
                                        )
                                    })
                                :
                                    <div style={{margin: "50px"}}> هیچ موردی یافت نشد </div>
                            :
                                filterProduct?.length > 0 ? 
                                    filterProduct?.map((item) => {
                                        return (
                                            <div className="p-Product" key={item.ID}>
                                                <div className='c-img'> <img  src={item.ImageURL} alt="محصول 1" /> </div>
                                                <div className='name-product'>
                                                <div className='handleText'> <span>{item.Name}</span> <span> {item.Details} </span> </div>
                                                <div className='showName-Details'> <div> <span>{item.Name}</span> <span> {item.Details} </span>  </div> </div>
                                                <div>{idCategory === 2004 ? idCompany != -1 ? nameCompany : item.CompanyName : item.CompanyName}</div>
                                                {/* item.CompanyName */}
                                                    {/* <p> 330،000 تومان </p> */}
                                                </div>
                                            </div>
                                        )
                                    })
                                :
                                <div style={{margin: "50px"}}> هیچ موردی یافت نشد </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='filter-produtc' >
                    <div className='middle-filter-product'  ref={menuRef}>
                        <div className="categore-products">
                            <div className='container-operationagreed-body-title'>
                                <div className="section-operationagreed-body-title">
                                    <div className={`slider-btn ${activeBtn}`} />
                                    <button className={`operationagreed-body-title_btn ${activeBtn === 'iron' ? 'active' : ''}`} onClick={()=>setActiveBtn('iron')}> آهن </button>
                                    <button className={`operationagreed-body-title_btn ${activeBtn === 'stone' ? 'active' : ''}`} onClick={()=>setActiveBtn('stone')}> سنگ </button>
                                </div>
                            </div>
                        </div>
                        <div className='nameProducts'>
                            <div style={{marginTop: "20px"}}>
                                { activeBtn === "stone" ?
                                    CategoryProductSang.map((item) => {
                                        return(
                                            <p className={`${item.ID === idCategory ? "active" : ""}`} key={item.ID} onClick={() => setIdCategory(item.ID)}>{item.Name}</p>
                                        )
                                    })
                                    :
                                    CategoryProductAhan.map((item) => {
                                        return(
                                            <p className={`${item.ID === idCategory ? "active" : ""}`} key={item.ID} onClick={() => setIdCategory(item.ID)}>{item.Name}</p>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    isMobile && isHamberGer ?
                        <HambergerMenue isHamberGer={isHamberGer} setIsHamberGer={setIsHamberGer} activeBtn={activeBtn} setActiveBtn={setActiveBtn} idCategory={idCategory} setIdCategory={setIdCategory}/>
                    :
                        ""
                }
        </div>
    </div>

  )
}

export default ShowAllProducts

function HambergerMenue ({isHamberGer , setIsHamberGer , activeBtn , setActiveBtn , idCategory , setIdCategory}){
    
    const [changeIdCategory , setchangeIdCategory] = useState(idCategory)
    const [changeCategory , setChangeCategory] = useState(activeBtn)

    const handleFilter = () => {
        setIsHamberGer(false)
        setActiveBtn(changeCategory)
        setIdCategory(changeIdCategory)
    }

    return(
        <>
            <div className='close-filter' onClick={() => setIsHamberGer(false)}></div>
            <div className={`container-h-menue ${isHamberGer ? "active" : ""} `}>
                <div className='title-modal-filter'>
                    <div onClick={() => setIsHamberGer(false)}> <XCircleIcon className='icon-close-filter'/>  </div>
                    <div> فیلتر </div>
                </div>
             <div className="categore-products">
                    <div className='container-operationagreed-body-title'>
                        <div className="section-operationagreed-body-title">
                            <div className={`slider-btn  ${changeCategory}`} />
                            <button className={`operationagreed-body-title_btn ${changeCategory === 'iron' ? 'active' : ''}`} onClick={()=>setChangeCategory('iron')}> آهن </button>
                            <button className={`operationagreed-body-title_btn ${changeCategory === 'stone' ? 'active' : ''}`} onClick={()=>setChangeCategory('stone')}> سنگ </button>
                        </div>
                    </div>
                </div>
                <div className='nameProducts h-m-li' >
                    <div>
                        {changeCategory === "stone" ? 
                            CategoryProductSang.map((item) => {
                                return(
                                    <p className={`${item.ID === changeIdCategory ? "active" : ""}`} key={item.ID} onClick={() => setchangeIdCategory(item.ID)}>{item.Name}</p>
                                )
                            })
                            :
                            CategoryProductAhan.map((item) => {
                                return(
                                    <p className={`${item.ID === changeIdCategory ? "active" : ""}`} key={item.ID} onClick={() => setchangeIdCategory(item.ID)}>{item.Name}</p>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='btn-setFilter'>
                    <button onClick={handleFilter}> اعمال فیلتر </button>
                </div>
                
            </div>
        </>
    )
}

function HiddenLoader(setIsLoader){
    setTimeout(() => {
        setIsLoader(false)
    }, 500);
}